import clsx from "clsx";
import React from "react";
import { useTheme } from "../../hooks/useTheme";
import Alert from "./Alert";
import { Message, MessageWrapper } from "./AlertStyles";
const AlertHolder = ({ alerts, onRemove, fullWidth = false, className = "", styles = {}, }) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.alert, ...styles };
    return (React.createElement("div", { className: clsx("best-alert-holder", className) }, !!alerts?.length && (React.createElement(MessageWrapper, null,
        React.createElement(Message, { style: { width: fullWidth ? "95%" : "" } }, alerts.map((alert, index) => (React.createElement(Alert, { id: alert.id, type: alert.type, 
            // eslint-disable-next-line
            key: `alert-${index}`, onRemove: onRemove, styles: StylesOverride }, alert.text))))))));
};
export default AlertHolder;
//# sourceMappingURL=AlertHolder.js.map